module.exports = __webpack_public_path__ + "static/media/banner-left-circle.65e19fb9.png";